import { render, staticRenderFns } from "./OptionCardCheckbox.vue?vue&type=template&id=bf3b6e0c"
import script from "./OptionCardCheckbox.vue?vue&type=script&lang=js"
export * from "./OptionCardCheckbox.vue?vue&type=script&lang=js"
import style0 from "./OptionCardCheckbox.vue?vue&type=style&index=0&id=bf3b6e0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports